var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('sub-title',[_vm._v("스포츠")]),_c('sports-game-type-selector'),_c('div',{staticStyle:{"width":"100%","margin-top":".1rem"}},_vm._l((_vm.games),function(item){return (item.isShow)?_c('sports-match-special-comp',{attrs:{"game":item}}):_vm._e()}),1),_c('my-unchecked-message-comp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }